import React, { Component } from 'react';
import '../assets/scss/sidebar-nav.scss';
import {
    FiChevronDown,
    FiChevronUp,
    FiFileText
} from "react-icons/all";
import { Link } from "react-router-dom";

class CentralNavBar extends Component {
    state = {
        navBar: [
            {
                id: 0,
                text: 'Distributors',
                path: '/dh/list',
                icon: <FiFileText />,
            },
            {
                id: 0,
                text: 'Commission Transactions',
                path: '/commssion-transactions/list',
                icon: <FiFileText />,
            },
            {
                id: 1,
                text: 'Purchase Orders',
                path: '/purchaseOrder/list',
                icon: <FiFileText />,
            },
            {
                id: 9,
                text: 'Supplier Payments',
                path: '/supplier-payments',
                icon: <FiFileText />,
            },
            {
                id: 3,
                text: 'DH Collections',
                path: '/dh-collections/list',
                icon: <FiFileText />,
            },
            // {
            //   id: 9,
            //   text: 'SR/Rider Collections',
            //   path: '/sr-rider-collections',
            //   icon: <FiFileText/>,
            // },
            {
                id: 2,
                text: 'Bank Accounts',
                path: '/bank-accounts/list',
                icon: <FiFileText />,
            },
            {
                id: 2,
                text: 'Suppliers',
                path: '/supplier/list',
                icon: <FiFileText />,
            },
            {
                id: 2,
                text: 'Order Payment Collection Report',
                path: '/payment-collection',
                icon: <FiFileText />,
            },
            {
                id: 2,
                text: 'Customer Acquisition',
                path: '/customer-acquisition',
                icon: <FiFileText />,
            },
        ]
    };

    toggleSubNavItems = async (id) => {
        const navBar = { ...this.state.navBar };
        const itemObj = await this.state.navBar.filter(obj => {
            return obj.id === id
        });
        const index = this.state.navBar.indexOf(itemObj[0]);
        navBar[index].isCollapsed = !navBar[index].isCollapsed;
        this.setState(navBar);
    };

    render() {
        return (
            <div className="sidebar-nav collapsed-sidebar">
                <ul className="navigation">
                    {this.state.navBar.map((item, i) => {
                        if (item.hasSubMenu) {
                            return (
                                <li key={i}
                                    className={item.isCollapsed ? 'has-sub-menu' : 'show-sub-menu has-sub-menu'}>
                                    <span
                                        onClick={() => this.toggleSubNavItems(item.id)}
                                        className="toggleCollapse nav-link">
                                        <span className="nav-icon">{item.icon}</span>
                                        <span className="nav-text">
                                            <span className="text">{item.text}</span>
                                            <span className="catet-icon">{item.isCollapsed ? <FiChevronDown /> : <FiChevronUp />}</span>
                                        </span>
                                    </span>

                                    <ul className="sub-menu">
                                        {item.subMenu.map((subItem, i) => {
                                            return (<li key={i}><Link className="nav-link" to={subItem.path}><span
                                                className="nav-text">{subItem.text}</span></Link></li>)
                                        })}
                                    </ul>
                                </li>
                            )
                        } else {
                            return (
                                <li key={i}>
                                    <Link className="nav-link" to={item.path}>
                                        <span className="nav-icon">{item.icon}</span>
                                        <span className="nav-text">{item.text}</span>
                                    </Link>
                                </li>
                            )
                        }
                    })}
                </ul>
            </div>
        );
    }
}

export default CentralNavBar;
